// import JobQueuePage from 'pages/common/IPriseJobs/JobQueuePage';
import { JobList } from 'pages/common/job/JobList';
import React from 'react';

export const JobPosting: React.FC<any> = () => {
  return <JobList />;
  // return <JobQueuePage />;
};
